import React, { Component, createRef } from 'react'
import { connect } from 'react-redux';
import Header from "../../Header/Header";
// import { loginActions } from '../../../action/loginAction';
import { withTranslation } from 'react-i18next';
import { gameActions } from '../../action/GameAction';
import { loginActions } from '../../action/loginAction';
import { history } from '../../helpers/history';
import { alertActions } from '../../action/AlertAction';
import HomeSlidTabs from '../Home/HomeSlidTabs';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import OnlineSlotHelmetOthers from '../Helmet/OnlineSlotHelmetOthers';

class SlotGame extends Component {
    constructor(props) {
        super(props);
        const _local_date = localStorage.getItem('slotgame') ? JSON.parse(localStorage.getItem('slotgame')) : {};
        if (Object.keys(_local_date).length == 0) {
            history.push('/instant')
        }
        this.state = {
            showPopUp: false,
            WindowUrl: _local_date.url,
            UserId: _local_date.userid,
            gameid: _local_date.gameid,
            typeid: _local_date.type,
            isFullscreen: false,
        }
        this.elementRef = createRef();
    }

    toggleFullscreen = () => {
        const { isFullscreen } = this.state;
        const elem = this.elementRef.current;

        if (!isFullscreen) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
        // Optimistically toggle, but the real state syncs in the fullscreenchange listener
        this.setState({ isFullscreen: !isFullscreen });
    };

    handleFullscreenChange = () => {
        const isFull = !!(
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement
        );
        this.setState({ isFullscreen: isFull });
    };


    componentDidMount() {
        window.p_mno = this.props.user.mobileNo;
        window.p_lKey = this.props.user.loginKey;
        window.p_lang = this.props.i18n.language;
        window.Refbalance = this.props.user.mobileNo != 0 ? this.props.getBalance : "";
        if (window.Refbalance) {
            window.addEventListener('message', window.myInstantBalRefresh, false);
            //window.addEventListener('message', window.Refbalance(_mno,_lKey,_lang), false);
        }

        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('msfullscreenchange', this.handleFullscreenChange);
    };


    static getDerivedStateFromProps(props, state) {
        return {
            casinoGames: props.casinogames,
        }
    };



    showMsg = (msg, flag) => {
        this.props.alertError(msg);
    }

    componentWillUnmount() {
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('msfullscreenchange', this.handleFullscreenChange);
    }



    render() {
        const { isFullscreen } = this.state;
        const { userId, gameUrl } = this.props;
        const { t } = this.props
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" &&
                    <>
                        <OnlineSlotHelmetOthers drawType={this.state.gameid} typeid={this.state.typeid} />
                    </>
                }

                < div className="mainContainer bg5" >
                    <Header />
                    <div class="container">
                        <HomeSlidTabs />
                        <div class="rht bg2">
                            <div ref={this.elementRef} className={`fullscreen-wrapper ${isFullscreen ? 'fullscreen' : ''}`}>
                                <div className="Iframe-cont">
                                    <iframe title="Game view"
                                        name={this.state.UserId}
                                        className="iframe"
                                        src={this.state.WindowUrl}
                                        allow="fullscreen"
                                        height="500px"
                                    ></iframe>
                                </div>
                                <div className="back-but-nav">
                                    <div className="back-to-games">
                                        {/* <NavLink to='/Instant'><FontAwesomeIcon icon={faArrowLeft} /> {t('lblback')} {t('lblGames')}</NavLink> */}
                                        <a onClick={() => { history.goBack() }}><FontAwesomeIcon icon={faArrowLeft} /> {t('lblback')} {t('lblGames')}</a>
                                    </div>
                                    <div className="full-screen-btn" onClick={() => { this.toggleFullscreen() }}><FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} /> {isFullscreen ? `${t('lblexit')} ${t('lblfullsce')}` : `${t('lblfullsce')}`}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>

        )
    };
}

function mapStateToProps(state) {
    console.log(state)
    const { appvariables, user } = state.loginReducer;
    const { casinogames } = state.gameReducer;
    return { appvariables, user, casinogames }
}

const mapActionToProps = {
    // GetCasinoGames:gameActions.GetCasinoGames,
    getBalance: loginActions.getBalance,
    GetCasinoGames: gameActions.GetCasinoGames,
    alertError: alertActions.error,
    UpdataBalance: loginActions.UpdataBalance
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(SlotGame))